<footer class="bottom">
  <div class="rodape-v2" style="justify-content: center;">
    <div class="logo-copy">
      <img *ngIf="!isCustomized" src="../../assets/img/PicPontos_logo.svg" alt="Logotipo">
      <h1 *ngIf="isCustomized" style="color: #17113f; font-weight: bold;">BEM VINDO!</h1>
    </div>
    <div class="separacao hidden-xs"></div>
    <div class="nav-direitos">
      <div>
        <ul class="footer-nav-list" *ngIf="!isCustomized">
          <li><a (click)="navigateTo('home')">Home</a></li>
          <li><a (click)="navigateTo('produtos')">Produtos</a></li>
          <li><a (click)="navigateTo('vantagens')">Vantagens</a></li>
          <li><a (click)="navigateTo('contato')">Contato</a></li>
        </ul>
      </div>
      <span>Todos os direitos reservados</span>
    </div>
  </div>
</footer>


// WEBPACK FOOTER //
// ./src/app/public/footer/footer.component.html